/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";
import Typical from "react-typical";

import "./Profile.css";

class Profile extends React.Component {
  render() {
    return (
      <div className='profile-container'>
        <div className='profile-parent'>
          <div className='profile-details'>
            <div className='colz'>
              <div className='colz-icon'>
                <a
                  target='_blank'
                  href='https://www.linkedin.com/in/devmonzer/'
                  rel='noreferrer'
                >
                  <i className='fa fa-linkedin fa-2x'></i>
                </a>
                <a target='_blank' href='https://github.com/DevMonzer'>
                  <i className='fa fa-github fa-2x'></i>
                </a>
                <a target='_blank' href='https://twitter.com/DevMonzer'>
                  <i className='fa fa-twitter fa-2x'></i>
                </a>
                <a
                  target='_blank'
                  href='https://www.facebook.com/profile.php?id=100075721583290'
                >
                  <i className='fa fa-facebook-square fa-2x'></i>
                </a>
              </div>
            </div>

            <div className='profile-details-name'>
              <span className='primary-text'>
                {" "}
                Hello, I'm{" "}
                <span className='highlighted-text'>Monzer Mohammed</span>
              </span>
            </div>
            <div className='profile-details-role'>
              <span className='primary-text'>
                {" "}
                <h1>
                  {" "}
                  <Typical
                    loop={Infinity}
                    steps={[
                      "JS Dev",
                      1000,
                      "Frontend Dev",
                      1000,
                      "React Dev",
                      1000,
                    ]}
                  />
                </h1>
                <span className='profile-role-tagline'>Do you want to</span>
              </span>
            </div>
            <div className='profile-options'>
              <a href='#contactMe' className='btn primary-btn button'>
                Hire Me
              </a>
              <a
                target='_blank'
                rel='noreferrer'
                href='https://drive.google.com/file/d/1sUX4kShhhst6RJT5ufRIPxxzkzgZwSKr/view?usp=sharing'
                download='Monzer Resume'
              >
                <button className='btn highlighted-btn'>Get Resume </button>
              </a>
            </div>
          </div>
          <div className='profile-picture'>
            <div className='profile-picture-background'></div>
          </div>
        </div>
      </div>
    );
  }
}

export default Profile;
